
// HorizontalMenu.js
import React from 'react';
import './HorizontalMenu.css'; 

const sendMessageToApp = (message) => {
  // iOS
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.reactNative) {
    window.webkit.messageHandlers.reactNative.postMessage(message);
  }
  // Android
  if (window.android) {
    window.android.postMessage(message);
  }
};


// 注意：我们使用 {...props} 来接收和应用外部的 className、style 等属性
const EmailIcon = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M4 8.25L10.5319 12.5366C11.0609 12.8837 11.3253 13.0573 11.613 13.1245C11.8671 13.1839 12.1329 13.1839 12.387 13.1245C12.6747 13.0573 12.9391 12.8837 13.4681 12.5366L20 8.25M7.84 18H16.16C17.5041 18 18.1762 18 18.6896 17.7548C19.1412 17.539 19.5083 17.1948 19.7384 16.7715C20 16.2902 20 15.6601 20 14.4V9.6C20 8.33988 20 7.70982 19.7384 7.22852C19.5083 6.80516 19.1412 6.46095 18.6896 6.24524C18.1762 6 17.5041 6 16.16 6H7.84C6.49587 6 5.82381 6 5.31042 6.24524C4.85883 6.46095 4.49168 6.80516 4.26158 7.22852C4 7.70982 4 8.33988 4 9.6V14.4C4 15.6601 4 16.2902 4.26158 16.7715C4.49168 17.1948 4.85883 17.539 5.31042 17.7548C5.82381 18 6.49587 18 7.84 18Z" stroke="#191919" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);

const ManualIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 19L11.92 18.8833C11.3642 18.0729 11.0864 17.6676 10.7193 17.3743C10.3943 17.1146 10.0198 16.9198 9.61728 16.8009C9.1626 16.6667 8.66169 16.6667 7.65986 16.6667H6.56C5.66392 16.6667 5.21587 16.6667 4.87362 16.4971C4.57256 16.348 4.32779 16.11 4.17439 15.8173C4 15.4846 4 15.049 4 14.1778V7.48889C4 6.6177 4 6.1821 4.17439 5.84935C4.32779 5.55665 4.57256 5.31868 4.87362 5.16955C5.21587 5 5.66392 5 6.56 5H6.88C8.67217 5 9.56825 5 10.2528 5.33909C10.8549 5.63736 11.3444 6.1133 11.6512 6.6987C12 7.3642 12 8.23539 12 9.97778M12 19V9.97778M12 19L12.08 18.8833C12.6358 18.0729 12.9136 17.6676 13.2807 17.3743C13.6057 17.1146 13.9802 16.9198 14.3827 16.8009C14.8374 16.6667 15.3383 16.6667 16.3401 16.6667H17.44C18.3361 16.6667 18.7841 16.6667 19.1264 16.4971C19.4274 16.348 19.6722 16.11 19.8256 15.8173C20 15.4846 20 15.049 20 14.1778V7.48889C20 6.6177 20 6.1821 19.8256 5.84935C19.6722 5.55665 19.4274 5.31868 19.1264 5.16955C18.7841 5 18.3361 5 17.44 5H17.12C15.3278 5 14.4317 5 13.7472 5.33909C13.1451 5.63736 12.6556 6.1133 12.3488 6.6987C12 7.3642 12 8.23539 12 9.97778" stroke="#191919" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

);


const SoundTuningIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18.7368 19V13.2353M12 19V10.7647M5.26316 19L5.26316 15.7059M13.1846 6.66971L17.5369 8.26585M10.9884 6.97723L6.27388 10.4352M19.63 7.8324C20.1233 8.31481 20.1233 9.09696 19.63 9.57937C19.1367 10.0618 18.337 10.0618 17.8437 9.57937C17.3504 9.09696 17.3504 8.31481 17.8437 7.8324C18.337 7.34999 19.1367 7.34999 19.63 7.8324ZM6.15635 10.303C6.64964 10.7854 6.64964 11.5675 6.15635 12.05C5.66305 12.5324 4.86326 12.5324 4.36997 12.05C3.87668 11.5675 3.87668 10.7854 4.36997 10.303C4.86326 9.82057 5.66305 9.82057 6.15635 10.303ZM12.8932 5.36181C13.3865 5.84422 13.3865 6.62637 12.8932 7.10878C12.3999 7.59119 11.6001 7.59119 11.1068 7.10878C10.6135 6.62637 10.6135 5.84422 11.1068 5.36181C11.6001 4.8794 12.3999 4.8794 12.8932 5.36181Z" stroke="#191919" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

);


const FAQsIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19 9.66667L19 5.00001M19 5.00001H14.3333M19 5.00001L12 12M10.4444 5H8.73333C7.42654 5 6.77315 5 6.27402 5.25432C5.83498 5.47802 5.47802 5.83498 5.25432 6.27402C5 6.77315 5 7.42654 5 8.73333V15.2667C5 16.5735 5 17.2269 5.25432 17.726C5.47802 18.165 5.83498 18.522 6.27402 18.7457C6.77315 19 7.42654 19 8.73333 19H15.2667C16.5735 19 17.2269 19 17.726 18.7457C18.165 18.522 18.522 18.165 18.7457 17.726C19 17.2269 19 16.5735 19 15.2667V13.5556" stroke="#191919" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

);




// 菜单数据结构：将导入的组件映射到 IconComponent 属性
const menuItems = [
  { name: 'Email Us', IconComponent: EmailIcon, action: 'Email Us' },
  { name: 'User Manual', IconComponent: ManualIcon, action: 'User Manual' },
  // { name: 'Sound Tuning', IconComponent: SoundTuningIcon, action: 'Sound Tuning' },
  { name: 'FAQs', IconComponent: FAQsIcon, action: 'FAQs' },
];

const HorizontalMenu = ({ onMenuClick }) => {
    /**
     * 按钮点击事件处理函数
     * @param {string} featureName - 被点击的按钮名称
     */
    const handleButtonClick = (featureName) => {
    console.log(`点击了: ${featureName}`);
        if(featureName === 'Sound Tuning'){
            onMenuClick(featureName);
        }
        else{
            sendMessageToApp(featureName);
        }
    
    //   if(featureName === 'Email Us'){}
    //   else if(featureName === 'User Manual'){       }
    //   else if(featureName === 'Sound Tuning'){       }
    //   else if(featureName === 'FAQs'){       }
    };

  return (
    <div className="menu-container">
      <div className="menu-list">
        {menuItems.map((item) => (
          <button
            key={item.name}
            className="menu-item-button"
            onClick={() => handleButtonClick(item.action)}
          >
            {/* 核心：使用大写字母 Item.IconComponent 渲染组件 */}
            {/* 这里的 className="menu-item-icon" 会作为 props 传递给 SVG 组件 */}
            <item.IconComponent className="menu-item-icon" /> 
            
            <span className="menu-item-text">{item.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default HorizontalMenu;